import { render, staticRenderFns } from "./CreateObservationModal.vue?vue&type=template&id=a379e59e&"
import script from "./CreateObservationModal.vue?vue&type=script&lang=js&"
export * from "./CreateObservationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports